import { Injectable } from '@angular/core';
import { Router, UrlTree, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({providedIn: null})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
      return new Promise(async (resolve) => {
        try {
          if (this.authService?.userValue?.userRole) {
            // Check if route is restricted by role
            if (this.getUserPrivilege(next)) {
              resolve(true);
            } else {
              resolve(false); 
            }
          } else {
            await this.authService.setUserData();
            if (this.authService?.userValue?.userRole) {
              // Check if route is restricted by role
              if (this.getUserPrivilege(next)) {
                resolve(true);
              } else {
                resolve(false); 
              }
            } else {
              resolve(false);
            }
          }
        } catch (error) {
          resolve(false); 
        }
      });
    }
    
    getUserPrivilege(next: ActivatedRouteSnapshot): boolean {
      if (next.data && next.data['roles'] && next.data['roles'].indexOf(this.authService.userValue?.userRole) === -1) {
        // Role not authorized, so redirect to home page
        // Write redirect navigation here
        return false;
      }
      // Authorized, so return true
      return true;
    }
}
